<div class="flex flex-row">
  <mat-icon>
    @switch (toast.type) {
      @case (toastType.info) {
        info
      }
      @case (toastType.success) {
        check
      }
      @case (toastType.warning) {
        warning
      }
      @case (toastType.error) {
        error
      }
    }
  </mat-icon>
  <span class="mat-body-2 bold ml1">{{toast.message}}</span>
</div>